import { _getItemFromLocal } from "./LocalKeys";

export const _isBifrostTokenCallRequired = () => {
  if(_getItemFromLocal("_btl")){
    const ttl = Number(_getItemFromLocal("_btl"));
    const expTime = new Date(ttl);
    const curTime = new Date();
    return expTime < curTime;
  }
  return true;
}
